module.exports = __webpack_public_path__ + "static/assets/694f1e4275d294f419efa0ddbb81aa17.svg";